module.exports = __webpack_public_path__ + "static/media/muffito_logo.069938a8.png";